export const jobsConstants = {
  UPDATE_JOBS: 'UPDATE_JOBS',
  UPDATE_REQUEST_JOBS: 'UPDATE_REQUEST_JOBS',
  UPDATE_REQUEST_DETAIL_JOBS: 'UPDATE_REQUEST_DETAIL_JOBS',

  SHOW_FORM: 'SHOW_FORM_JOBS',

  UPDATE_FILTERS: 'UPDATE_FILTERS_JOBS',

  UPDATE_COMPANIES: 'UPDATE_COMPANIES_CANDIDATE',
  UPDATE_COMPANIES_DETAIL: 'UPDATE_COMPANIES_DETAIL_CANDIDATE',
  UPDATE_COMPANIES_DETAIL_JOBS: 'UPDATE_COMPANIES_DETAIL_JOBS',

  UPDATE_APPLICANTS: 'UPDATE_APPLICANTS',

  UPDATE_APPLICANTIONS: 'UPDATE_APPLICANTIONS_CANDIDATE',

  SUCCESS: 'SUCCESS_ALERT',

  UPDATE_REQUEST_DETAIL_APPLICANT_JOBS: 'UPDATE_REQUEST_DETAIL_APPLICANT_JOBS',
  UPDATE_LOADING: 'IS_LOADING_JOBS',
  UPDATE_ERROR: 'UPDATE_ERROR_JOBS',
};
